import { cronJobsServiceBaseUrl } from "../../../../../../services/http";

export const cronJobsServiceEndpoints = {
    accountingCron : {
        triggerCron : `${cronJobsServiceBaseUrl}/accounting/triggerAccountingCron`,
        cronStatus : `${cronJobsServiceBaseUrl}/accounting/accountingCronStatus`,
    }
}